import React, { CSSProperties, FC } from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { StepIconProps, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import {
    StyledCompletedStepIcon,
    StyledStep,
    StyledStepConnector,
    StyledStepIcon,
    StyledStepLabel,
    StyledStepperHorizontal,
} from "./styled";

export type StepProps = {
    label: string;
    stepId: number;
};

type StepBarProps = {
    currentStep: number;
    steps: StepProps[];
    style?: CSSProperties;
    onClick?: (step: number) => void;
};

function CustomStepIcon(props: StepIconProps) {
    const { active, completed, icon } = props;
    if (completed) {
        return <StyledCompletedStepIcon data-testid="step-bar-item-checked" />;
    }
    return (
        <StyledStepIcon $active={active}>
            <circle cx="12" cy="12" r="11" strokeWidth="1" />
            <text x="12" y="15" textAnchor="middle">
                {icon}
            </text>
        </StyledStepIcon>
    );
}

const StepBar: FC<StepBarProps> = ({ steps, style, currentStep, onClick = null }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <StyledStepperHorizontal
            style={style}
            classes={{ root: "stepper-root", horizontal: "stepper-horizontal", vertical: "stepper-vertical" }}
            connector={<StyledStepConnector />}
        >
            {steps.map(({ label, stepId }) => {
                const allowClick = onClick && !isMobileScreen && stepId < currentStep;
                return (
                    <StyledStep
                        data-testid={`stepbar-step-${stepId}`}
                        key={`stepbar-step-${stepId}`}
                        className={clsx(allowClick && "pointer")}
                        onClick={() => (allowClick ? onClick(stepId) : {})}
                        active={currentStep === stepId}
                        completed={stepId < currentStep}
                        disabled={false}
                    >
                        <StyledStepLabel
                            classes={{
                                root: "steplabel-root",
                                label: "steplabel-label",
                                active: "steplabel-active",
                                completed: "steplabel-completed",
                            }}
                            StepIconComponent={CustomStepIcon}
                        >
                            {t(label)}
                        </StyledStepLabel>
                    </StyledStep>
                );
            })}
        </StyledStepperHorizontal>
    );
};

export default StepBar;
